module.exports = __webpack_public_path__ + "images/illustrations/kitchen/resp-supercarers-connecting-people-who-care2.495b0da36062e2d677c5c262cb5aa677.png";